import { SET_GL_ACCOUNT_CODES, SET_GL_ACCOUNT_CODE_SAVE } from "./GLAccountCodesType"

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_GL_ACCOUNT_CODES:
            return {
                ...state,
                glAccountCodes: action.codes
            };
        case SET_GL_ACCOUNT_CODE_SAVE:
            return {
                ...state,
                glAccountCodeSave: action.glAccountCodeSave
            };
        default:
            return state;
    }
};

export default reducer;